import axios from "axios";
import { apiUrl } from "../config/appConfig";
import { TimeStampPastDate } from "../utils/checkTimeStamp";
import { clearSession, refreshTokenFn } from "../utils/session";
// import { debounce } from "lodash";

export const http = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: "application/json",
  },
  timeout: 30000, // 30 seconds timeout
});

export const http2 = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
  timeout: 60000, // 60 seconds timeout for AI requests
});

// Modified custom debounce to handle async nature of refreshTokenFnDebounced
function debounce(fn, delay) {
  let timeoutId;
  let pendingResolvers = [];
  let lastArgs;
  return function (...args) {
    lastArgs = args;
    const promise = new Promise((resolve) => {
      pendingResolvers.push(resolve);
    });
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(async () => {
      const result = await fn.apply(this, lastArgs);
      pendingResolvers.forEach((resolve) => resolve(result));
      pendingResolvers = [];
    }, delay);
    return promise;
  };
}

const refreshTokenFnDebounced = debounce(async () => {
  const refreshToken = await refreshTokenFn();
  return refreshToken;
}, 1000);

// Request interceptor
http.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem("token");
    const expireAt = localStorage.getItem("expireAt");

    // Check if the access token is expired
    if (TimeStampPastDate(expireAt)) {
      // Token is expired, refresh it
      token = await refreshTokenFnDebounced();

      if (token) {
        // Update the config headers with the new access token
        // config.headers["Authorization"] = `Bearer ${token}`;
        // window.location.reload();
      } else {
        // Handle the case when the token refresh failed
        clearSession();
        window.location.reload();
        return Promise.reject("Redirecting to Login!");
      }
    } else {
      // Token is not expired, add it to the request headers
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
